A partner-provided unique ID for this choice.

This can be used to correlate the choice back to its corresponding representation in your software.

This must be unique across all choices in the question.
